module.exports = __webpack_public_path__ + "738c44ced8ba14753549fdb2415d5971.svg";